import md5 from "blueimp-md5";

const configDirective = {

    getConfigData() {
        //don't change this, use the .env value provided.
        return JSON.parse(process.env.VUE_APP_CONFIG_DATA);
    },

    hasNsim() {
        if (typeof this.getConfigData()["site-settings"]["has_nsim"] == "boolean") {
            if (this.getConfigData()["site-settings"]["has_nsim"]) {
                // if (process.env.NODE_ENV === "development") {
                //     console.log("has_nsim = true");
                // }
                return true;
            } else {
                // if (process.env.NODE_ENV === "development") {
                //     console.log("has_nsim = false");
                // }
                return false;
            }
        }else{
            if (this.getConfigData()["site-settings"]["has_nsim"] && this.getConfigData()["site-settings"]["has_nsim"].toLowerCase() === "true") {
                // if (process.env.NODE_ENV === "development") {
                //     console.log("has_nsim = true");
                // }
                return true;
            } else {
                // if (process.env.NODE_ENV === "development") {
                //     console.log("has_nsim = false");
                // }
                return false;
            }
        }
    },

    isIOTOnly() {
        if (this.getConfigData()["site-settings"]["iot_only"] && this.getConfigData()["site-settings"]["iot_only"].toLowerCase() === "true") {
            return true;
        } else {
            return false;
        }
    },

    hasDataPlans() {
        if (this.getConfigData()["site-settings"]["has_data_plans"] && this.getConfigData()["site-settings"]["has_data_plans"].toLowerCase() === "false") {
            return false;
        } else {
            return true;
        }
    },

    getConfigSiteSetting() {
        if (this.getConfigData()) {
            return this.getConfigData()["site-settings"];
        }
    },

    getCarrier() {
        if (this.getConfigData())
            if (this.getConfigData()["carrier"])
                return this.getConfigData()["carrier"];
            else
                return process.env.VUE_APP_CLIENT;
        else
            return process.env.VUE_APP_CLIENT;
    },

    getTroubleLinks() {
        if (this.getConfigData())
            if (this.getConfigData()["navigation"]['Troubleshooting']['child'])
                return this.getConfigData()["navigation"]['Troubleshooting']['child'];
            else
                return {};
        else
            return {};
    },

    getDashboardToolTip() {
        let toolTipsJson =
            {
                "tooltips": {
                    "iot_dashboard": {
                        "data_session_tooltip": "The number of data sessions of the entire SIM estate in the selected period",
                        "data_volume_tooltip": "The amount of megabytes consumed in the selected period",
                        "alerts_tooltip": "The number of watchdog alerts such as fencing alerts, IMEI lock alerts etc. in the selected period",
                        "zero_sessions_tooltip": "The number of connections which yielded no traffic",
                        "data_volume_by_period_tooltip": "The amount of data volume trends projected through line chart in the selected period",
                        "data_volume_by_region_tooltip": "The amount data volume by region in the selected period",
                        "watchdog_alerts_tooltip": "Total alerts by period",
                        "top_metrics_data_volume_tooltip": "Data Volume: top data usage by imsi, Data Sessions: top # of data sessions by imsi, Alerts: top # of alerts by imsi, Zero Sessions: top # of zero sessions by imsi ",
                        "sim_inventory_tooltip": "The inventory and types available in the system"
                    }
                }
            };
        if (toolTipsJson.tooltips) {
            return toolTipsJson.tooltips["iot_dashboard"];
        }
    },

    getSearchDetailToolTip() {

        let toolTipsJson =
            {
                "tooltips": {
                    "sim_details": {
                        "data_sessions_tooltip": "The number of data sessions of the entire SIM estate in the selected period",
                        "data_volume_tooltip": "The amount of megabytes consumed in the selected period",
                        "alerts_tooltip": "The number of watchdog alerts such as fencing alerts, IMEI lock alerts etc. in the selected period",
                        "zero_sessions_tooltip": "The number of connections which yielded no traffic",
                        "current_data_sessions_tooltip": "SIM current data session",
                        "state_tooltip": "This will help you to change the provision a sim.",
                        "watchdog_alerts_tooltip": "This will help you to manage watchdogs.",
                        "datavolume_chart_tooltip": "The amount of data volume projected through line chart in the selected period",
                        "orders_tooltip": "List of SIM Orders"
                    }
                }
            };
        if (toolTipsJson.tooltips) {
            return toolTipsJson.tooltips["sim_details"];
        }
        // if (this.getConfigData() && this.getConfigData().tooltips) {
        //     return this.getConfigData().tooltips["sim_details"];
        // }
    },

    getDefaultCFNumber() {
        if (this.getConfigData()) {
            return this.getConfigSiteSetting()["default_cf_number"];
        }
    },

    getIMSIPrefixes() {
        if (this.getConfigData()) {
            return this.getConfigSiteSetting()["imsi_prefixes"];
        }
    },

    getServerTimeZone() {
        return "America/Chicago";
        // if (this.getConfigData()) {
        // 	return this.getConfigData()["overwatch-settings"]["timeZone"];
        // }
    },

    getServerOffSet() {
        return -600;
        // if (this.getConfigData()) {
        // 	return this.getConfigData()["overwatch-settings"]["offset"];
        // }
    },

    getInfluxSettingsUrl() {
        return this.getInfluxSettingCustomer().url;
    },

    getInfluxSettingsDB() {
        this.getInfluxSettingCustomer().db;
    },

    getInfluxSettingCustomer() {

        return {
            "url": "https://api.dccllc.net/diameter",
            "db": "diameter",
            "precision": "ms",
            "auth": "aW5wX3VzZXI6aW5wUHdk",
            "customer": process.env.VUE_APP_CLIENT
        };

        // if (this.getConfigData()) {
        // 	return this.getConfigData()["influx-settings"].customer;
        // }
    },

    getCurrentUser() {
        if (this.getConfigData()) {
            //console.log('getCurrentUser', JSON.parse(sessionStorage.getItem("IOT_GetCurrentUser")));
            return JSON.parse(sessionStorage.getItem("IOT_GetCurrentUser"));
        }
    },

    getCustomerInfo() {
        if (this.getConfigData()) {
            return JSON.parse(sessionStorage.getItem("IOT_GetCustomerInfo"));
        }
    },

    //don't change this.
    getOverwatchBaseURL() {
        return "https://api.dccllc.net/overwatch";
        // if (this.getConfigData()) {
        // 	return this.getConfigData()["api-settings"]["overwatch_baseurl"];
        // }
    },

    getCustomerAvatar() {
        if (this.getConfigData()) {
            if (sessionStorage.getItem("avatar")) return sessionStorage.getItem("avatar");
            let user = sessionStorage.getItem("IOT_GetCurrentUser");
            if (user) user = JSON.parse(user);
            // if (user['custom:avatar']) return user['custom:avatar'];
            let avatar;
            let hash;
            if (user && user.email) {
              hash = md5(user.email);
            } else {
              hash = md5("example@test.com");
            }
            return avatar = "//www.gravatar.com/avatar/" + hash + "?d=retro";
        }
    },

    getGoogleApiKey() {
        return "AIzaSyAcmjrQRsekNZhgSu2woT-myga1MytO87s"; //new from jake June 19, 2023
        // if (process.env.VUE_APP_GOOGLE_MAP_TOKEN) {
        //     return process.env.VUE_APP_GOOGLE_MAP_TOKEN;
        // } else {
        //     return "AIzaSyCznOKgnePSN6gIYjYU9iL6EAhZBaaKXto";
        // }
        // if (this.getConfigData() && this.getConfigData()["api-settings"]) {
        // 	return this.getConfigData()["api-settings"]["google_map_api_key"];
        // }
    },

    getRegisterStatus() {
        return false;
        // let config = this.getConfigData();
        // if (config && config['api-settings'] && config['api-settings']['has_registration']){
        // 	return config['api-settings']['has_registration'];
        // } else {
        // 	return false;
        // }
    },

    getReportsList(reportType) {
        if (this.getConfigData()) {
            if (reportType !== "admin") reportType = "default";
            return this.getConfigData()["reports"]["list"][reportType];
        }
    },

    getReportColumns(reportName) {
        if (this.getConfigData()) {
            return this.getConfigData()["reports"]["columns"][reportName];
        }
    },

    getCordovaReportsList() {
        if (this.getConfigData() && this.getConfigData()["cordova-reports"]) {
            return this.getConfigData()["cordova-reports"]["list"];
        }
    },

    getCordovaConfigColumn() {
        if (this.getConfigData() && this.getConfigData()["cordova-reports"]) {
            return this.getConfigData()["cordova-reports"]["columns"];
        }
    },

    getReportLink() {
        return process.env.VUE_APP_REPORT_LINK
    },

    getNavigation() {
        if (process.env.VUE_APP_NAVIGATION) {
            return process.env.VUE_APP_NAVIGATION
        } else {
            return {};
        }
    },

    getNavigationDetails() {
        if (this.getConfigData() && this.getConfigData()["navigation-side"]) {
            return this.getConfigData()["navigation-side"];
        } else {
            return {};
        }
    }


    /*
getSupportContact() {
  let support_email = 'crosenbohm@dccllc.net';
  //todo: fix configdata reference
  // if (this.getConfigData()) {
  //   try {
  //     if ( typeof this.getConfigData()['site-settings']['support_email'] !== 'undefined')
  //     support_email = this.getConfigData()['site-settings']['support_email'];
  //   } catch { }
  // }
  return support_email;
}
 */
};

export default configDirective;
